import { render, staticRenderFns } from "./ErrorPopup.vue?vue&type=template&id=87e41bd4"
import script from "./ErrorPopup.vue?vue&type=script&lang=ts"
export * from "./ErrorPopup.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports